(function () {
  function getPageAttr(name) {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return '';
    return page.getAttribute(name) || '';
  }

  function getConfig(overrides) {
    overrides = overrides || {};
    var base = window.TamburCheckout || {};
    return {
      shop: overrides.shop || base.shop || getPageAttr('data-shop-domain'),
      token: overrides.token || base.storefrontToken || getPageAttr('data-storefront-token'),
      countryCode: overrides.countryCode || base.countryCode || getPageAttr('data-country')
    };
  }

  function syncCartBuyerIdentity(opts) {
    opts = opts || {};
    var cfg = getConfig(opts);
    if (!cfg.shop || !cfg.token) return Promise.resolve();

    var identity = {};
    if (cfg.countryCode) identity.countryCode = cfg.countryCode;
    if (opts.deliveryMethod) {
      identity.preferences = { delivery: { deliveryMethod: opts.deliveryMethod } };
    }
    if (!identity.countryCode && !identity.preferences) return Promise.resolve();

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.token) throw new Error('Cart-token saknas');
        return fetch('https://' + cfg.shop + '/api/2026-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': cfg.token
          },
          body: JSON.stringify({
            query:
              'mutation TamburCartPref($cartId: ID!, $identity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $identity) { userErrors { message field } } }',
            variables: {
              cartId: 'gid://shopify/Cart/' + cart.token,
              identity: identity
            }
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (body) {
            var payload = body.data && body.data.cartBuyerIdentityUpdate;
            if (payload && payload.userErrors && payload.userErrors.length) {
              throw new Error(payload.userErrors.map(function (err) { return err.message; }).join(', '));
            }
            if (body.errors && body.errors.length) {
              throw new Error(body.errors.map(function (err) { return err.message; }).join(', '));
            }
          });
      });
  }

  window.TamburCheckoutSync = {
    sync: syncCartBuyerIdentity,
    hasToken: function (overrides) {
      var cfg = getConfig(overrides);
      return Boolean(cfg.shop && cfg.token);
    }
  };

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = (link.getAttribute('href') || '').trim();
    if (href !== '/checkout' && href.indexOf('/checkout?') !== 0) return;
    if (!window.TamburCheckoutSync.hasToken()) return;
    if (link.getAttribute('data-checkout-sync') === 'skip') return;
    if (link.getAttribute('data-checkout-busy') === 'true') return;

    e.preventDefault();
    link.setAttribute('data-checkout-busy', 'true');
    window.TamburCheckoutSync.sync()
      .then(function () { window.location.href = href; })
      .catch(function () {
        link.removeAttribute('data-checkout-busy');
        var msg =
          (window.TamburCheckout && window.TamburCheckout.prepareCheckoutError) ||
          'Could not prepare checkout. Try again.';
        alert(msg);
      });
  }, true);
})();
